import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';

import { ResponsiveImage } from '@fcom/ui-components/components/images';
import { LanguageService } from '@fcom/ui-translate/services/language.service';
import { CmsImageData } from '@fcom/core-api/interfaces';

@Component({
  selector: 'fin-corporate-widget',
  templateUrl: './corporate-widget.component.html',
  styleUrl: './corporate-widget.component.scss',
})
export class CorporateWidgetComponent implements OnInit {
  @Input()
  imageFromFragment: string;

  @Input()
  image$: Observable<CmsImageData>;

  bannerImage$: Observable<ResponsiveImage>;

  constructor(
    private languageService: LanguageService,
    private httpClient: HttpClient
  ) {}

  ngOnInit(): void {
    this.bannerImage$ =
      this.image$ ??
      this.languageService.translate(this.imageFromFragment).pipe(
        take(1),
        map((translation) => translation?.picture?.jsonUrl),
        filter(Boolean),
        switchMap((jsonUrl: string) => this.httpClient.get<ResponsiveImage>(jsonUrl))
      );
  }
}
